
/*
* 讲师
*/

<template>
  <div class="hbn-container" id="Teacher">
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="form"
            label-width="80px"
            label-position="right"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="讲师">
                  <el-input
                    id="name"
                    v-model="PageQuery.queryModel.name"
                    placeholder="讲师"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button size="mini" class="hbn-button-serach" @click="seach"
              >查找</el-button
            >
            <span class="control-collapse" @click="show = !show">{{
              show ? "收起" : "展开"
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>

    <div class="hbn-table-screen">
      <div class="operation">
        <el-button
          class="custom-button"
          type="primary"
          :icon="Search"
          @click="TeacherEdit(-1, 'Add')"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>新增</span>
        </el-button>
        <!-- <el-button v-show="false" type="primary" class="custom-button" @click="importExcel">
          <i class="el-icon-upload custom-icon"></i>
          <span>导入</span>
        </el-button>
        <el-button v-show="false" type="primary" class="custom-button" @click="export2Excel">
          <i class="el-icon-download custom-icon"></i>
          <span>导出</span>
        </el-button> -->
      </div>
      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            :data="DataList"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            @checkbox-all="selectAllChangeEvent"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
            :checkbox-config="tableCheckboxConfig">
          >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>

            <vxe-column field="imgUrl" title="头像"  width="80">
              <template #default="{ row }">
                <img
                  :src="headIMG(row.imgUrl)"
                  style="width: 50px;height:50px;cursor:pointer" >
              </template>
            </vxe-column>

            <template v-for="(item, key) in TeacherList" :key="key">
              <vxe-table-column
                v-if="item.isShow"
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                show-overflow-tooltip
                :class-name="JSON.stringify(item)"
                :formatter="formatterData"
              />
            </template>

            <vxe-table-column
              width="200"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ rowIndex, row }">
                <el-button
                  v-show="row.status != 1"
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Modify')"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Detail')"
                  >查看</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleClick(rowIndex, 'Delete')"
                  >删除</el-button
                >

              </template>
            </vxe-table-column>
          </vxe-table>
        </div>

        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
          </vxe-pager>
        </div>
      </div>
    </div>
    <TeacherEdit
      ref="TeacherEdit"
      v-model:dialogVisible="dialogVisible"
      @close-dialog="closeDialog"
      @handle-cancel="handleCancel"
      @handle-confirm="handleConfirm"
    ></TeacherEdit>
  </div>
</template>

<script>
import { Search, Delete } from "@element-plus/icons";
import { TeacherList } from "@/assets/apiData/Course/TeacherList";
import { GetDataByPageQuery, DeleteTeacher, ModifyTeacher } from "@api/Course/ApiTeacher";

import TeacherEdit from "@comp/Course/TeacherEdit.vue";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
// import XEUtils from "xe-utils";
import { ElMessageBox } from "element-plus";
import { ossPreview } from "@/util/ossClient.js"
import { dateFormat } from "@/util/utils.js";

export default {
  data() {
    return {
      PageQuery: {
        queryModel: {
          name: "",
        },
        pageindex: 1,
        PageSize: 20,
      },
      total: 0,
      multipleSelection: [],
      dialogVisible: false,
      UpLoaddialogVisible: false,
      seldata: {
        dialogGUID: "",
        dialogtype: "",
      },
      show: false,
      Industry: {
        CodeID: "",
        Name: "",
      },
      TeacherList: [],
      DataList: [],
      url: "",
      importurl: "/api/IndustrialUnit/ImportExcel?tabname=Industry",
      tableCheckboxConfig: {
        checkMethod: ({ row }) => {
          return row.status != 1
        },
      }
    };
  },
  components: {
    TeacherEdit,
    excel,
    Search,
  },
  computed: {
    checkendSum() {
      return this.multipleSelection.length;
    },
  },
  methods: {
    //章节图片路径设定
    headIMG(img) {
      const imgData = require('../../assets/images/logo.png')
      if(img) {
        if (img.indexOf("https://") > -1) return img;
        return ossPreview(img, "1")
      } else {
        return imgData;
      }
      // return img ? img : imgData
    },
    formatterData:function({cellValue, row, column}){
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS",cellValue)
          break;
        case "level":
          cellValue = cellValue == "0" ? "初级": cellValue == "1" ?"中级": "高级";
          break;
        case "isTopTeacher":
          cellValue = cellValue ? "是": "否";
          break;
      }
      return cellValue;
    },
    error() {},
    success() {},
    closeUpDialog() {
      this.UpLoaddialogVisible = false;
    },
    importExcel() {
      //this.url="/api/IndustrialUnit/ImportExcel";
      this.UpLoaddialogVisible = true;
    },
    export2Excel() {
      const v = this;
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径

        const tHeader = [
          ...Enumerable.from(v.TeacherList)
            .select((item) => {
              return item.label;
            })
            .toArray(),
        ]; // 讲师
        const filterVal = [
          ...Enumerable.from(v.TeacherList)
            .select((item) => {
              return item.prop;
            })
            .toArray(),
        ]; // 导出的字段名
        const list = v.DataList;
        const data = v.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, `所属行业`);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    handleClick(index, type) {
      console.log(index, type);

      this.TeacherEdit(index, type);
    },
    TeacherEdit(index, type) {
      var _this = this;
      if (type == "Delete") {
        ElMessageBox.confirm(
          `是否要删除?`,
          "提示",
          {
            cancelButtonClass: "cancelstyle",
            confirmButtonClass: "confirmstyle",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
          }
        )
          .then(() => {
            DeleteTeacher(this.DataList[index].id).then(function (data) {
              if (data) {
                _this.$message.success("删除成功");
                _this.PageQuery.pageindex = 1;
                _this.GetData();
              }
            });
          })
          .catch(() => {
            return;
          });
      } else {
        this.dialogVisible = true;
        var obj={}
        if (type != "Add") obj = _this.DataList[index];
        this.$refs.TeacherEdit.loadDataById(obj, type);
      }
    },
    //选中事件
    handleSelectionChange({ records }) {
      this.multipleSelection = records;
    },
    //全选
    selectAllChangeEvent({ checked, records }){
      this.multipleSelection = records;
    },
    seach() {
      this.PageQuery.pageindex = 1;
      this.GetData();
    },

    handleSizeChange(val) {
      //分页
    },
    handlePageChange({ currentPage, pageSize }) {
      if (this.PageQuery.PageSize != pageSize) {
        this.PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        this.PageQuery.PageSize = pageSize;
      } else {
        this.PageQuery.pageindex = currentPage;
      }
      this.GetData();
    },
    handleCurrentChange({ row }) {
      // console.log(val);
      // this.GetData();
    },
    SearchDataInfo() {},
    GetData() {
      const _this = this;
      this.SearchDataInfo();
      try {
        GetDataByPageQuery(JSON.stringify(this.PageQuery)).then(function (
          data
        ) {
          _this.DataList = data.entities;
          _this.total = data.totalCount;
        });
      } catch (e) {
        console.log(e);
      }
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    handleConfirm(val) {
      this.dialogVisible = false;
      this.PageQuery.pageindex = 1;
      this.GetData();
    },
  },
  created() {
    this.TeacherList = TeacherList;
    this.GetData();
  },
};
</script>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";
.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}
.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
#userInfo {
}
</style>
<style scoped>
</style>
